import {
  ORDER_HISTORY_DETAIL_SET_ADD_TO_CART_LOADING,
  ORDER_HISTORY_DETAIL_PRODUCT_SELECTION,
  ORDER_HISTORY_DETAIL_PRODUCT_DESELECTION,
  ORDER_HISTORY_DETAIL_LOAD_ERROR
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const initialState = {
  isAddingToCart: false,
  errors: {},
  selectedOrderRowList: [],
};

export const orderHistory = (state = initialState, action) => {
  switch (action.type) {
    case ORDER_HISTORY_DETAIL_PRODUCT_SELECTION:
      return {
        ...state,
        selectedOrderRowList: [...state.selectedOrderRowList, action.payload],
      };

    case ORDER_HISTORY_DETAIL_PRODUCT_DESELECTION:
      return {
        ...state,
        selectedOrderRowList: state.selectedOrderRowList.filter((id) => id !== action.payload),
      };
    case ORDER_HISTORY_DETAIL_SET_ADD_TO_CART_LOADING:
      return {
        ...state,
        isAddingToCart: action.payload,
      };
    case ORDER_HISTORY_DETAIL_LOAD_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    default:
      return state;
  }
};
